import { style } from "@vanilla-extract/css";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { transition } from "@huub-web/ui/utils/transition";

export const containerStyle = style({
  backgroundColor: theme.colors.tertiary,
  color: theme.colors.onTertiary,
  padding: `${theme.spacings.xxs} ${theme.spacings.xs}`,
  borderRadius: theme.borderRadiuses.s,
  transform: "translate(-50%, -50%)",
  cursor: "pointer",
  transition: transition("background-color"),
  selectors: {
    "&:hover": {
      backgroundColor: theme.colors.primary,
      color: theme.colors.onPrimary,
    },
  },
});
